import styled, { css } from 'styled-components'
import { FlexContainer } from '@edulastic/common'
import { white } from '@edulastic/colors'

import { Nav } from '../../../../../assessment/themes/common'

export const StyledWrapper = styled(FlexContainer)`
  background: ${({ background }) => background};
  height: ${({ height }) => height};
  min-height: ${({ minHeight }) => minHeight};
  border-bottom-right-radius: ${({ borderBottomRightRadius }) =>
    borderBottomRightRadius};
  border-bottom-left-radius: ${({ borderBottomLeftRadius }) =>
    borderBottomLeftRadius};
`
const ArrowStyle = css`
  max-width: 30px;
  font-size: 26px;
  border-radius: 0px;
  left: 0px;
  svg {
    fill: #878a91;
    path {
      fill: unset;
    }
  }
  .help-text {
    color: #878a91;
  }

  &:hover {
    svg {
      fill: ${white};
    }
    .help-text {
      color: ${white};
      font-size: 20;
      font-weight: 600;
    }
  }
`

export const PrevArrow = styled(Nav.BackArrow)`
  ${ArrowStyle};
`

export const NextArrow = styled(Nav.NextArrow)`
  ${ArrowStyle};
  left: unset;
  right: 0px;
`
export const PrevArrowTTS = styled(PrevArrow)`
  .help-text {
    color: #878a91;
    font-size: 11px;
  }
  &:hover {
    .help-text {
      color: ${white};
    }
  }
  transform: unset;
`
export const NextArrowTTS = styled(NextArrow)`
  .help-text {
    color: #878a91;
    font-size: 11px;
  }
  &:hover {
    .help-text {
      color: ${white};
    }
  }
  transform: unset;
`
export const Title = styled(FlexContainer)`
  font-weight: bold;
  font-size: 20px;
  user-select: none;
`

export const ModalContentArea = styled.div`
  border-radius: ${({ tts }) => (tts ? '8px' : '0px')};
  padding: 0px 30px;
  height: ${({ isMobile }) => (isMobile ? 'calc(100vh - 100px)' : '100%')};
  width: ${({ width }) => width};
`

export const PreviewPopupOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`
